import { IS_SSR } from '@src/lib/server-side-rendering'
import { DependencyList, EffectCallback, useEffect, useMemo } from 'react'

export function useUniversalEffect(effect: EffectCallback, deps: DependencyList = []) {
  if (IS_SSR) {
    useMemo(effect, deps)
  } else {
    useEffect(effect, deps)
  }
}
